import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import ReviewUserTargetBlock from 'modules/reviews/components/ReviewUserTargetBlock'
import ResponseValues from 'modules/reviews/components/WriteResponse/ResponseValues'
import { getQuestionGroupData } from 'modules/reviews/pages/performance/ReviewAnswer/SplitViewReviewAnswerPage/getQuestionGroupData'
import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

import { Blank } from './Blank'

interface Props {
  managerQuestionGroup: QuestionGroup
  selfQuestionGroup: QuestionGroup
  assessCompetencies: boolean
}

const Body = ({ managerQuestionGroup, selfQuestionGroup, assessCompetencies }: Props) => {
  const { respondent, respondentJobTitle, targetUser, targetUserjobTitle } =
    getQuestionGroupData(managerQuestionGroup)
  const {
    respondent: answerUser,
    respondentJobTitle: answerJobTitle,
    targetUser: answerTargetUser,
    targetUserjobTitle: answerTargetUserjobTitle,
  } = getQuestionGroupData(selfQuestionGroup)

  return (
    <Box gap="s40">
      <Box flexDirection="row" gap="s32">
        <Box style={{ flex: '1' }}>
          {managerQuestionGroup && (
            <ReviewUserTargetBlock
              respondent={respondent}
              description={respondentJobTitle}
              target={targetUser}
              targetDescription={targetUserjobTitle}
              ariaLabel="Manager review"
            >
              {managerQuestionGroup.canSeeAnswers ? (
                <ResponseValues
                  questionGroup={managerQuestionGroup}
                  assessCompetencies={assessCompetencies}
                />
              ) : (
                <Blank />
              )}
            </ReviewUserTargetBlock>
          )}
        </Box>
        <Box style={{ flex: '1' }}>
          {selfQuestionGroup && (
            <ReviewUserTargetBlock
              respondent={answerUser}
              description={answerJobTitle}
              target={answerTargetUser}
              targetDescription={answerTargetUserjobTitle}
              ariaLabel="Self review"
            >
              {selfQuestionGroup.canSeeAnswers ? (
                <ResponseValues
                  questionGroup={selfQuestionGroup}
                  assessCompetencies={assessCompetencies}
                />
              ) : (
                <Blank />
              )}
            </ReviewUserTargetBlock>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default Body
